import { Paragraph } from '@purpur/library';
import './RichtextAuthor.scss';

type RichtextAuthorProps = {
  fullName: string;
  position: string;
  url: string;
};

const RichtextAuthor = ({ fullName, position, url }: RichtextAuthorProps) => {
  return (
    <div className="richtext-component__author">
      <div className="richtext-component__author-details">
        <Paragraph variant="paragraph-100-medium">{fullName}</Paragraph>
        <Paragraph variant="paragraph-100-medium">{position}</Paragraph>
      </div>
      <img src={url} alt={fullName} className="richtext-component__author__image" />
    </div>
  );
};

export default RichtextAuthor;
